import React, { Fragment, FunctionComponent, useEffect } from 'react';
import { FormSpy } from 'react-final-form';
import { ErrorMessage } from '../../../utils/shared/interfaces';
import {
  beforeNow,
  validDay,
  yearAfter1900,
} from '../../../utils/shared/validations';
import MemberId from './MemberId';
import AllowDepReg from './AllowDepReg';
import PrimaryForm from './PrimaryForm';

export const validate = (values) => {
  const errors: {
    isDependent?: string;
    relationship?: string;
    primaryGender?: string;
    primaryDobMonth?: ErrorMessage;
    primaryDobDay?: ErrorMessage;
    primaryDobYear?: string;
  } = {};
  if (!values.isDependent) {
    errors.isDependent = 'Required';
  }
  if (values.isDependent === 'true') {
    if (!values.relationship) {
      errors.relationship = 'Required';
    }
    if (!values.primaryGender) {
      errors.primaryGender = 'Required';
    }
  }
  if (values.primaryDobMonth) {
    if (!values.primaryDobDay) errors.primaryDobDay = 'Required';

    if (!values.primaryDobYear) errors.primaryDobYear = 'Required';

    if (
      values.primaryDobDay &&
      values.primaryDobMonth &&
      values.primaryDobYear &&
      values.primaryDobYear.length === 4
    ) {
      errors.primaryDobMonth =
        beforeNow(
          `${values.primaryDobMonth}/${values.primaryDobDay}/${values.primaryDobYear}`
        ) || yearAfter1900(values.primaryDobYear);
      if (errors.primaryDobMonth) {
        errors.primaryDobDay = ' ';
        errors.primaryDobYear = ' ';
      } else {
        errors.primaryDobDay = validDay(
          values.primaryDobDay,
          values.primaryDobMonth,
          values.primaryDobYear
        );
      }
    }
  }
  return errors;
};

const InsuranceDetailFields: FunctionComponent = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.createPageLoadEvent) {
      window.createPageLoadEvent('/insurance#insuranceId');
    }
  }, []);

  return (
    <FormSpy subscription={{ values: true }}>
      {({ values }) => (
        <Fragment>
          <MemberId affiliationId={values.affiliationId} />
          <AllowDepReg affiliationId={values.affiliationId} />
          {values.isDependent === 'true' ? <PrimaryForm /> : null}
        </Fragment>
      )}
    </FormSpy>
  );
};

export default InsuranceDetailFields;
